import ctaBannerImage from '../../../assets/images/cta-banner.jpg';
import { TEL_HREF, WHATSAPP_CHAT_URL } from '../../../config/contactLinks';

export default function CtaBanner() {
  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={ctaBannerImage}
          alt="NiğPak Temizlik profesyonel hizmet"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-navy/80" />
        {/* Subtle pattern overlay */}
        <div className="absolute inset-0 opacity-10"
          style={{ backgroundImage: 'radial-gradient(circle, #c9a84c 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 md:px-8 py-24 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-10 h-[2px] bg-gold rounded-full" />
          <span className="text-gold text-[11px] font-bold uppercase tracking-[0.25em]">Hemen Başlayalım</span>
          <div className="w-10 h-[2px] bg-gold rounded-full" />
        </div>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight mb-6">
          Temiz Bir Alan İçin<br />
          <span className="text-gold">Bugün Adım Atın.</span>
        </h2>

        <p className="text-white/60 text-base leading-relaxed mb-10 max-w-xl mx-auto">
          Ücretsiz keşif ve fiyat teklifi için bizimle iletişime geçin. Niğde&apos;nin en hızlı ve güvenilir temizlik ekibi yanınızda.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
            className="flex items-center gap-2 bg-gold hover:bg-gold-dark text-white font-bold px-8 py-4 rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer">
            <i className="ri-whatsapp-line text-lg"></i>
            WhatsApp ile Teklif Al
          </a>
          <a href={TEL_HREF}
            className="flex items-center gap-2 border-2 border-white/30 hover:border-gold text-white hover:text-gold font-bold px-8 py-4 rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer">
            <i className="ri-phone-line text-base"></i>
            0543 191 0851
          </a>
        </div>

        {/* Trust row */}
        <div className="flex items-center justify-center gap-8 flex-wrap mt-12 pt-10 border-t border-white/10">
          {[
            { icon: 'ri-shield-check-line', text: 'Sigortalı Ekip' },
            { icon: 'ri-time-line', text: '2 Saat İçinde Yanıt' },
            { icon: 'ri-thumb-up-line', text: '%100 Memnuniyet' },
            { icon: 'ri-refresh-line', text: 'Ücretsiz Keşif' },
          ].map(t => (
            <div key={t.text} className="flex items-center gap-2 text-white/60">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${t.icon} text-gold text-base`}></i>
              </span>
              <span className="text-xs font-semibold">{t.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
